import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const ItemInvoiceToggle = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);

    const { formData, updateFormData } = usePartnerForm();

    const handleToggleChange = (value) => {
        updateFormData(FORM_FIELD_PATHS.BILL_ONE_LINE, value);
    };

    return (
        <>
            <FormControl
                sx={{ margin: '0 !important' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={{ ...stackStyling(), height: 'auto' }}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Single Item Invoice
                    </FormLabel>
                    <Box flex={1} maxWidth="400px">
                        <Field
                            component={BooleanToggle}
                            id="billOneLine"
                            name="billOneLine"
                            paddingTop="20px"
                            isChecked={
                                formData.partnerBillingSettings?.billOneLine ??
                                false
                            }
                            onChange={handleToggleChange}
                        />
                        {isHovered && (
                            <FieldToolTip
                                label="Show invoice as single line item"
                                ariaLabel="bill-one-line-tip"
                                left="25px"
                            />
                        )}
                    </Box>
                </Stack>
            </FormControl>
        </>
    );
};

export default ItemInvoiceToggle;
